module.exports = __webpack_public_path__ + "img/jht-icon-33.553ad297.png";